/**
 * PrintLineItemsTable — the order's line items as a plain table for paper.
 * Shared by the email print (Email + Order) and the order print.
 */
import type { OrderLineItem } from '../../types/orders';
import { formatPrintPrice, lineItemsTotal } from './printLineItems';
import styles from './PrintLineItemsTable.module.css';

const PrintLineItemsTable: React.FC<{ lineItems: OrderLineItem[] }> = ({ lineItems }) => (
  <table className={styles.table} data-testid="print-line-items">
    <thead>
      <tr>
        <th className={styles.pos}>#</th>
        <th className={styles.code}>Item Code</th>
        <th>Description</th>
        <th className={styles.qty}>Qty</th>
        <th className={styles.price}>Unit Price</th>
        <th className={styles.total}>Line Total</th>
      </tr>
    </thead>
    <tbody>
      {lineItems.map((li) => (
        <tr key={li.id}>
          <td className={styles.pos}>{li.position}</td>
          <td className={styles.code}>{li.item_code}</td>
          <td>
            {li.item_description}
            {li.sage_comment_text && <div className={styles.comment}>{li.sage_comment_text}</div>}
          </td>
          <td className={styles.qty}>{li.quantity}</td>
          <td className={styles.price}>{formatPrintPrice(li.unit_price)}</td>
          <td className={styles.total}>{formatPrintPrice(li.line_total)}</td>
        </tr>
      ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan={5} className={styles.totalLabel}>Total</td>
        <td className={styles.totalValue}>{formatPrintPrice(lineItemsTotal(lineItems))}</td>
      </tr>
    </tfoot>
  </table>
);

export default PrintLineItemsTable;
